import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function StudyMbbsInBarbados() {
  return <section data-section-id="241819" id="join-our-care-family" className="relative bg-cover bg-center bg-no-repeat bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1665643/img/healthcare_recruitment_bg.png)] py-20 md:py-32 text-foreground">
      <div className="absolute inset-0 bg-background/95 backdrop-blur-[2px]"></div>
      <div className="container relative z-10 mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 items-start">
          <div className="lg:col-span-10 lg:col-start-2 space-y-8">
            <div className="flex flex-col items-start space-y-4">
              <div className="space-y-2">
                <h2 className="text-3xl md:text-4xl font-bold font-default text-foreground uppercase tracking-wider">
                  A Rewarding Career in Care
                </h2>
                <p className="text-lg font-semibold text-muted-foreground font-default italic">
                  Join the Cynthylee Health Care Family
                </p>
              </div>
              <div className="w-16 h-1.5 bg-primary rounded-lg"></div>
            </div>
            <div className="flex flex-col gap-8 items-start">
              <div className="w-full">
                <p className="text-base md:text-lg leading-relaxed text-foreground/80 font-default max-w-3xl">
                  At Cynthylee Health Care, we believe that exceptional care starts with exceptional people. Operating across Brighton & Hove, we are looking for compassionate, dedicated individuals to join our CQC-registered team. Whether you are an experienced healthcare professional or looking to start your journey in the care sector, we provide the comprehensive support, professional training, and welcoming community you need to thrive. By joining us, you become part of a family committed to making a real, lasting difference in the lives of our elderly and vulnerable clients every single day. We value empathy, reliability, and a genuine passion for helping others maintain their independence and dignity at home.
                </p>
                <div className="mt-8">
                  <Button asChild size="lg" className="rounded-lg px-8 py-6 text-lg font-semibold shadow-lg hover:shadow-xl transition-all duration-300">
                    <Link to="/ContactPage">Apply Now</Link>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}